import React, {Component, useEffect, useLayoutEffect, useRef, useState} from 'react';
import EnhancedTable from '../general/table.js';
import Config from '../config.js';
import {Button, Card, CardContent, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, Link as MuiLink, Tab, Tabs, TextField, Toolbar, Typography, withStyles} from '@material-ui/core';
import axios from 'axios';
import CompanyLogos from './logos.js';
import RichTextEditor from 'react-rte';
import ExtendedSelect from '../general/select.js';
import {getCompanyNames, readFileAsync} from '../helpers.js';
import Auth from '../auth.js';
import ContentLoader from "../general/content_loader";
import CatalogManagerResults from "../catalogmanager/components/CatalogManagerResults";
import {fetchCompanyProfile, putCompanyProfile} from "../utils/api";
import GenericDialog from "../catalogmanager/components/Dialogs/GenericDialog";
import DownloadButton from "../general/download_button";
import moment from "moment";
import DropZone from "../files/dropzone";
import {parse} from 'csv-parse/lib/sync';
import {stringify} from 'csv-stringify/lib/sync';
import FileSaver from "filesaver.js-npm";

const styles = {
    card: {
        display: 'flex',
        flexDirection: 'column',
        '& > div': {
            marginBottom: '0.5em'
        }
    }
};

//region constants
const timezones = ['(UTC-12:00) International Date Line West', '(UTC-11:00) Coordinated Universal Time-11', '(UTC-10:00) Aleutian Islands', '(UTC-10:00) Hawaii', '(UTC-09:30) Marquesas Islands', '(UTC-09:00) Alaska', '(UTC-09:00) Coordinated Universal Time-09', '(UTC-08:00) Baja California', '(UTC-08:00) Coordinated Universal Time-08', '(UTC-08:00) Pacific Time (US & Canada)', '(UTC-07:00) Arizona', '(UTC-07:00) La Paz, Mazatlan', '(UTC-07:00) Mountain Time (US & Canada)', '(UTC-07:00) Yukon', '(UTC-06:00) Central America', '(UTC-06:00) Central Time (US & Canada)', '(UTC-06:00) Easter Island', '(UTC-06:00) Guadalajara, Mexico City, Monterrey', '(UTC-06:00) Saskatchewan', '(UTC-05:00) Bogota, Lima, Quito, Rio Branco', '(UTC-05:00) Chetumal', '(UTC-05:00) Eastern Time (US & Canada)', '(UTC-05:00) Haiti', '(UTC-05:00) Havana', '(UTC-05:00) Indiana (East)', '(UTC-05:00) Turks and Caicos', '(UTC-04:00) Asuncion', '(UTC-04:00) Atlantic Time (Canada)', '(UTC-04:00) Caracas', '(UTC-04:00) Cuiaba', '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan', '(UTC-04:00) Santiago', '(UTC-03:30) Newfoundland', '(UTC-03:00) Araguaina', '(UTC-03:00) Brasilia', '(UTC-03:00) Cayenne, Fortaleza', '(UTC-03:00) City of Buenos Aires', '(UTC-03:00) Montevideo', '(UTC-03:00) Punta Arenas', '(UTC-03:00) Saint Pierre and Miquelon', '(UTC-03:00) Salvador', '(UTC-02:00) Coordinated Universal Time-02', '(UTC-02:00) Greenland', '(UTC-02:00) Mid-Atlantic - Old', '(UTC-01:00) Azores', '(UTC-01:00) Cabo Verde Is.', '(UTC) Coordinated Universal Time', '(UTC+00:00) Dublin, Edinburgh, Lisbon, London', '(UTC+00:00) Monrovia, Reykjavik', '(UTC+00:00) Sao Tome', '(UTC+01:00) Casablanca', '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', '(UTC+01:00) West Central Africa', '(UTC+02:00) Athens, Bucharest', '(UTC+02:00) Beirut', '(UTC+02:00) Cairo', '(UTC+02:00) Chisinau', '(UTC+02:00) Gaza, Hebron', '(UTC+02:00) Harare, Pretoria', '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', '(UTC+02:00) Jerusalem', '(UTC+02:00) Juba', '(UTC+02:00) Kaliningrad', '(UTC+02:00) Khartoum', '(UTC+02:00) Tripoli', '(UTC+02:00) Windhoek', '(UTC+03:00) Amman', '(UTC+03:00) Baghdad', '(UTC+03:00) Damascus', '(UTC+03:00) Istanbul', '(UTC+03:00) Kuwait, Riyadh', '(UTC+03:00) Minsk', '(UTC+03:00) Moscow, St. Petersburg', '(UTC+03:00) Nairobi', '(UTC+03:00) Volgograd', '(UTC+03:30) Tehran', '(UTC+04:00) Abu Dhabi, Muscat', '(UTC+04:00) Astrakhan, Ulyanovsk', '(UTC+04:00) Baku', '(UTC+04:00) Izhevsk, Samara', '(UTC+04:00) Port Louis', '(UTC+04:00) Saratov', '(UTC+04:00) Tbilisi', '(UTC+04:00) Yerevan', '(UTC+04:30) Kabul', '(UTC+05:00) Ashgabat, Tashkent', '(UTC+05:00) Astana', '(UTC+05:00) Ekaterinburg', '(UTC+05:00) Islamabad, Karachi', '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', '(UTC+05:30) Sri Jayawardenepura', '(UTC+05:45) Kathmandu', '(UTC+06:00) Bishkek', '(UTC+06:00) Dhaka', '(UTC+06:00) Omsk', '(UTC+06:30) Yangon (Rangoon)', '(UTC+07:00) Bangkok, Hanoi, Jakarta', '(UTC+07:00) Barnaul, Gorno-Altaysk', '(UTC+07:00) Hovd', '(UTC+07:00) Krasnoyarsk', '(UTC+07:00) Novosibirsk', '(UTC+07:00) Tomsk', '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi', '(UTC+08:00) Irkutsk', '(UTC+08:00) Kuala Lumpur, Singapore', '(UTC+08:00) Perth', '(UTC+08:00) Taipei', '(UTC+08:00) Ulaanbaatar', '(UTC+08:45) Eucla', '(UTC+09:00) Chita', '(UTC+09:00) Osaka, Sapporo, Tokyo', '(UTC+09:00) Pyongyang', '(UTC+09:00) Seoul', '(UTC+09:00) Yakutsk', '(UTC+09:30) Adelaide', '(UTC+09:30) Darwin', '(UTC+10:00) Brisbane', '(UTC+10:00) Canberra, Melbourne, Sydney', '(UTC+10:00) Guam, Port Moresby', '(UTC+10:00) Hobart', '(UTC+10:00) Vladivostok', '(UTC+10:30) Lord Howe Island', '(UTC+11:00) Bougainville Island', '(UTC+11:00) Chokurdakh', '(UTC+11:00) Magadan', '(UTC+11:00) Norfolk Island', '(UTC+11:00) Sakhalin', '(UTC+11:00) Solomon Is., New Caledonia', '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky', '(UTC+12:00) Auckland, Wellington', '(UTC+12:00) Coordinated Universal Time+12', '(UTC+12:00) Fiji', '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', '(UTC+12:45) Chatham Islands', '(UTC+13:00) Coordinated Universal Time+13', '(UTC+13:00) Nuku\'alofa', '(UTC+13:00) Samoa', '(UTC+14:00) Kiritimati Island'];

const categories = [
    "Animals and Pets",
    "Apparel, Footwear and Accessories",
    "Arts and Crafts",
    "Baby and Toddler",
    "Business and Industrial",
    "Cleaning Supplies",
    "Electronics",
    "Food and Beverages",
    "Hardware",
    "Health and Beauty Care",
    "Home, Furniture and Appliances",
    "Home Improvement",
    "Luggage and Bags",
    "Office Supplies",
    "Patio and Garden",
    "Personal Protective Equipment",
    "Religious and Ceremonial",
    "School Supplies",
    "Seasonal",
    "Software",
    "Sports and Fitness",
    "Toys and Games",
    "Vehicles and Parts",
    "Wine and Spirits"
].map(r => ({label: r, value: r}));

export const defaultProfile = {
    Id: null,
    CompanyName: "",
    Description: "",
    Categories: [],
    Subcategory: "",
    ShareProfile: true,
    Website: "",
    CustomerServiceContact: {
        FirstName: "",
        LastName: "",
        Email: "",
        Title: ""
    },
    ITContact: {
        FirstName: "",
        LastName: "",
        Email: "",
        Title: ""
    },
    MerchandiserContact: {
        FirstName: "",
        LastName: "",
        Email: "",
        Title: ""
    },
    OperationsContact: {
        FirstName: "",
        LastName: "",
        Email: "",
        Title: ""
    },
    PartnershipContact: {
        FirstName: "",
        LastName: "",
        Email: "",
        Title: ""
    },
    Closures: [],
    Hours: [],
    Warehouses: []
}

const defaultWarehouse = {
    Name: "",
    Code: "",
    Address1: "",
    Address2: "",
    Type: "",
    City: "",
    State: "",
    Zip: "",
    Country: ""
}

const defaultHour = {
    TimeZone: "",
    Day: "",
    OpenTime: "",
    CloseTime: "",
    Closed: false
}

const defaultClosure = {
    Day: "",
    StartTime: "",
    EndTime: "",
    Warehouses: []
}
//endregion

//region Helpers
const splitAndTrimmedWarehouses = (warehouses) => {
    return warehouses.split(',').map(w => w.trim());
}

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`profile-tabpanel-${index}`}
            aria-labelledby={`profile-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>{children}</>
            )}
        </div>
    );
}

const warehouseImportMapper = (records) => {
    let mappedData = [];

    records.forEach((row, index) => {
        let warehouse = {
            Name: row.Name,
            Type: row.Type,
            Code: row.Code,
            Address1: row.Address1,
            Address2: row.Address2,
            City: row.City,
            State: row.State,
            Zip: row.Zip,
            Country: row.Country
        }
        mappedData.push(warehouse);
    });

    return mappedData;
}

const closureImportMapper = (records) => {
    let mappedData = [];

    records.forEach((row, index) => {
        let closure = {
            Day: row.Day,
            Start: row.Start,
            End: row.End,
            Warehouses: row["Warehouse Codes"] ? splitAndTrimmedWarehouses(row["Warehouse Codes"]) : []
        }
        mappedData.push(closure);
    });

    return mappedData;
}

const ImportDialog = (props) => {
    const {open, setOpen, title, mapFunction, setError, updateProfile} = props;
    const {headers} = props;
    const [importFile, setImportFile] = React.useState(null);

    const onDrop = (files) => {
        if(files && files.length > 0){
            setImportFile(files[0]);
        }
    }

    const bulkImport = async () => {
        try {
            let input = await readFileAsync(importFile);
            let records = parse(input, {columns: true, skip_empty_lines: false});
            await updateProfile(mapFunction(records));
        } catch (err) {
            let error = 'Unexpected error.';
            if (err.response && err.response.data && err.response.data.error) {
                error = err.response.data.error;
            }
            setError(error);
        }

        setImportFile(null);
        setOpen(false);
    }

    const downloadTemplate = () => {
        let blob = new Blob([
            headers.join(',')
        ], { type: "text/csv" });
        FileSaver.saveAs(blob, 'template.csv');
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
            <Toolbar className='lbtoolbar'>{title}</Toolbar>
            <Typography style={{padding: "0 24px"}}>
                <MuiLink
                    style={{lineHeight: 'inherit', fontSize: 'inherit', fontFamily: 'inherit', verticalAlign: 'top'}}
                    component='button' onClick={downloadTemplate}>
                    Download template.
                </MuiLink>
            </Typography>
            <DialogContent>
                <DropZone accept=".csv" style={{height: '10em'}} onDrop={onDrop}>
                    {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
                        if (isDragAccept || isDragReject) {
                            return "Drop here to upload this file.";
                        }
                        return importFile ? importFile.name : 'Drop a CSV file here or click to choose a file.';
                    }}
                </DropZone>
            </DialogContent>
            <DialogActions>
                <DownloadButton color="primary" onClick={bulkImport} type='submit'
                                disabled={!importFile || !importFile.name}>
                    Import
                </DownloadButton>
            </DialogActions>
        </Dialog>
    )
}
//endregion

//region Dialogs
const MerchandisingDialog = (props) => {
    const {open, setOpen, disableEdit} = props;
    const {profile, setProfile} = props;
    const {setErrors} = props;

    const [editProfile, setEditProfile] = React.useState({...defaultProfile, ...profile});

    const saveMerchandising = async () => {
        const formattedProfile = {...editProfile};
        formattedProfile.Description = formattedProfile.Description.toString('html');
        const response = await putCompanyProfile(formattedProfile);
        if (response.success) {
            setProfile({...response.data});
            setOpen(false);
        } else {
            setErrors(response.error.Message);
        }
    }

    useLayoutEffect(() => {
        let formattedProfile = {...defaultProfile, ...profile};
        if (!props.profile.Description) {
            formattedProfile.Description = RichTextEditor.createEmptyValue();
        } else {
            formattedProfile.Description = RichTextEditor.createValueFromString(props.profile.Description, 'html');
        }

        if (!props.profile.Categories) {
            formattedProfile.Categories = [];
        }

        if (props.profile.ShareProfile !== false) {
            formattedProfile.ShareProfile = true;
        }

        setEditProfile(formattedProfile);

        // eslint-disable-next-line
    }, [props.profile]);

    return (
        <Dialog
            disableEscapeKeyDown={disableEdit}
            disableBackdropClick={disableEdit}
            maxWidth="lg"
            open={open}
            onClose={() => setOpen(false)}
            fullWidth={true}
        >
            <Toolbar className='lbtoolbar'>Edit Profile</Toolbar>
            <DialogContent style={{flexDirection: 'row', display: 'flex', gap: '1em'}}>
                <div style={{width: '25em'}}>
                    <Typography variant='h6'>Basics</Typography>
                    <div style={{flexDirection: 'row', display: 'flex', gap: '1em'}}>
                        <TextField InputLabelProps={{shrink: true}} disabled={disableEdit} style={{flex: 1}}
                                   label='Merchandiser First Name' value={editProfile.MerchandiserContact.FirstName || ''}
                                   onChange={(e) => setEditProfile({
                                        ...editProfile,
                                        MerchandiserContact: {
                                            ...editProfile.MerchandiserContact,
                                            FirstName: e.target.value
                                        }
                                   })}/>
                        <TextField InputLabelProps={{shrink: true}} disabled={disableEdit} style={{flex: 1}}
                                   label='Merchandiser Last Name' value={editProfile.MerchandiserContact.LastName || ''}
                                   onChange={(e) => setEditProfile({
                                        ...editProfile,
                                        MerchandiserContact: {
                                            ...editProfile.MerchandiserContact,
                                            LastName: e.target.value
                                        }
                                   })}/>
                    </div>
                    <div style={{flexDirection: 'row', display: 'flex', gap: '1em'}}>
                        <TextField InputLabelProps={{shrink: true}} disabled={disableEdit} style={{flex: 1}}
                                   label='Merchandiser Title' value={editProfile.MerchandiserContact.Title || ''}
                                   onChange={(e) => setEditProfile({
                                        ...editProfile,
                                        MerchandiserContact: {
                                            ...editProfile.MerchandiserContact,
                                            Title: e.target.value
                                        }
                                   })}/>
                        <TextField InputLabelProps={{shrink: true}} disabled={disableEdit} style={{flex: 1}}
                                   label='Merchandiser Email Address' value={editProfile.MerchandiserContact.Email || ''}
                                   onChange={(e) => setEditProfile({
                                        ...editProfile,
                                        MerchandiserContact: {
                                            ...editProfile.MerchandiserContact,
                                            Email: e.target.value
                                        }
                                   })}/>
                    </div>
                    <div style={{flexDirection: 'row', display: 'flex'}}>
                        <TextField InputLabelProps={{shrink: true}} disabled={disableEdit} style={{flex: 1}}
                                   label='Your Website' value={editProfile.Website || ''}
                                   onChange={(e) => setEditProfile({
                                        ...editProfile,
                                        Website: e.target.value
                                   })}/>
                    </div>
                    <div style={{flexDirection: 'row', display: 'flex'}}>
                        <ExtendedSelect disabled={disableEdit} style={{flex: 1}} label='Categories'
                                        value={editProfile.Categories} options={categories}
                                        onChange={(e) => {
                                            setEditProfile({
                                                ...editProfile,
                                                Categories: e
                                            })
                                        }}
                        />
                    </div>
                    <div style={{flexDirection: 'row', display: 'flex'}}>
                        <TextField InputLabelProps={{shrink: true}} disabled={disableEdit} style={{flex: 1}}
                                   label='Subcategory' value={editProfile.Subcategory || ''}
                                   onChange={(e) => setEditProfile({
                                        ...editProfile,
                                        Subcategory: e.target.value
                                   })}/>
                    </div>
                    <div style={{display: 'flex', flexDirection: "column"}}>
                        <FormControlLabel
                            control={<Checkbox disabled={disableEdit} checked={editProfile.ShareProfile}/>}
                            label='Share my profile on the Connected Commerce Network®' onChange={(e) => setEditProfile({
                                ...editProfile,
                                ShareProfile: e.target.checked
                        })}/>

                        <Typography>
                            Your profile and information above will be visible to retailers and marketplace operators in
                            our network and they may contact you directly to establish a commercial relationship
                        </Typography>
                    </div>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                    <Typography variant='h6'>Description</Typography>
                    <div style={{display: 'flex', maxHeight: '300px', flexDirection: 'row'}}>
                        <RichTextEditor className='textEditor' disabled={disableEdit} value={editProfile.Description}
                                        onChange={(value) => setEditProfile({
                                            ...editProfile,
                                            Description: value
                                        })}/>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button type='submit' disabled={disableEdit} onClick={() => saveMerchandising()} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const ContactsDialog = (props) => {
    const {open, setOpen, selectedContact} = props;
    const {profile, setProfile} = props;
    const {allowManagement, setErrors} = props;

    const [editProfile, setEditProfile] = React.useState({...defaultProfile, ...profile});

    const saveChanges = async () => {
        if (!allowManagement) return;
        const response = await putCompanyProfile(editProfile);
        if (response.success) {
            setProfile({...response.data});
            setOpen(false);
        } else {
            setErrors(response.error.Message);
        }
    }

    return (
        <Dialog
            maxWidth="md"
            open={open}
            onClose={() => setOpen(false)}
            fullWidth={true}
        >
            <Toolbar className='lbtoolbar'>
                Edit Contact
            </Toolbar>
            <DialogContent>
                <Grid container style={{gap: '1em'}}>
                    <Grid container item xs={12} style={{gap: "0.5rem"}}>
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='First Name' value={editProfile[selectedContact.type]?.FirstName ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                        setEditProfile((prev) => ({
                                             ...prev,
                                             [selectedContact.type]: {
                                                  ...prev[selectedContact.type],
                                                 FirstName: value
                                             }
                                        }))
                                   }}
                        />
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='Last Name' value={editProfile[selectedContact.type]?.LastName ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setEditProfile((prev) => ({
                                           ...prev,
                                           [selectedContact.type]: {
                                               ...prev[selectedContact.type],
                                               LastName: value
                                           }
                                       }))
                                   }}
                        />
                    </Grid>
                    <Grid container item xs={12} style={{gap: "0.5rem"}}>
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='Email Address' value={editProfile[selectedContact.type]?.Email ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setEditProfile((prev) => ({
                                           ...prev,
                                           [selectedContact.type]: {
                                               ...prev[selectedContact.type],
                                               Email: value
                                           }
                                       }))
                                   }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                {allowManagement && (
                    <Button
                        type='submit'
                        color="primary"
                        onClick={() => saveChanges()}
                    >
                        Save
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}

const WarehousesDialog = (props) => {
    const {open, setOpen, selectedWarehouse} = props;
    const {profile, setProfile} = props;
    const {allowManagement, setErrors} = props;

    const [warehouseDetails, setWarehouseDetails] = React.useState({...defaultWarehouse, ...selectedWarehouse});

    const saveChanges = async () => {
        if (!allowManagement) return;
        let newWarehouses = [...profile.Warehouses];
        if (selectedWarehouse) {
            newWarehouses[selectedWarehouse.index] = warehouseDetails;
        } else {
            newWarehouses.push(warehouseDetails);
        }

        const response = await putCompanyProfile({
            ...profile,
            Warehouses: newWarehouses,
            Closures: profile.Closures.map(c => ({
                ...c,
                Warehouses: c.Warehouses ? c.Warehouses.map(w => w === warehouseDetails.Code ? warehouseDetails.Code : w) : []
            }))
        });
        if (response.success) {
            setProfile({...response.data});
            setOpen(false);
        } else {
            setErrors(response.error.Message);
        }
    }

    return (
        <Dialog
            maxWidth="md"
            open={open}
            onClose={() => setOpen(false)}
            fullWidth={true}
        >
            <Toolbar className='lbtoolbar'>Edit Warehouse</Toolbar>
            <DialogContent>
                <Grid container style={{gap: '1em'}}>
                    <Grid container item xs={12} style={{gap: "0.5rem"}}>
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='Warehouse Name' value={warehouseDetails?.Name ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setWarehouseDetails((prev) => ({
                                           ...prev,
                                           Name: value
                                       }))
                                   }}
                        />
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='Warehouse Code' value={warehouseDetails?.Code ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setWarehouseDetails((prev) => ({
                                           ...prev,
                                           Code: value
                                       }))
                                   }}
                        />
                    </Grid>
                    <Grid container item xs={12} style={{gap: "0.5rem"}}>
                        <ExtendedSelect
                            disabled={!allowManagement} style={{flex: 1}} label='Warehouse Type'
                            value={warehouseDetails.Type}
                            options={[
                                {label: 'Warehouse', value: 'Warehouse'},
                                {label: 'Externally-Managed', value: 'Externally-Managed'},
                                {label: 'Dropship', value: 'Dropship'},
                                {label: 'Retail Store', value: 'Retail Store'},
                            ]}
                            onChange={(e) => {
                                setWarehouseDetails((prev) => ({
                                    ...prev,
                                    Type: e
                                }))
                            }}
                        />
                    </Grid>
                    <Grid container item xs={12} style={{gap: "0.5rem"}}>
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='Address Line 1' value={warehouseDetails?.Address1 ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setWarehouseDetails((prev) => ({
                                           ...prev,
                                           Address1: value
                                       }))
                                   }}
                        />
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='Address Line 2' value={warehouseDetails?.Address2 ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setWarehouseDetails((prev) => ({
                                           ...prev,
                                           Address2: value
                                       }))
                                   }}
                        />
                    </Grid>
                    <Grid container item xs={12} style={{gap: "0.5rem"}}>
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='City' value={warehouseDetails?.City ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setWarehouseDetails((prev) => ({
                                           ...prev,
                                           City: value
                                       }))
                                   }}
                        />
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='State' value={warehouseDetails?.State ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setWarehouseDetails((prev) => ({
                                           ...prev,
                                           State: value
                                       }))
                                   }}
                        />
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='Zip Code' value={warehouseDetails?.Zip ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setWarehouseDetails((prev) => ({
                                           ...prev,
                                           Zip: value
                                       }))
                                   }}
                        />
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='Country' value={warehouseDetails?.Country ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setWarehouseDetails((prev) => ({
                                           ...prev,
                                           Country: value
                                       }))
                                   }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                {allowManagement && (
                    <Button
                        type='submit'
                        color="primary"
                        onClick={() => saveChanges()}
                    >
                        Save
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}

const ClosuresDialog = (props) => {
    const {open, setOpen, selectedClosure} = props;
    const {profile, setProfile} = props;
    const {allowManagement, setErrors} = props;

    const [closureDetails, setClosureDetails] = React.useState({...defaultClosure, ...selectedClosure});

    const checks = () => {
        if (!closureDetails.Start) {
            setErrors('Start date is required');
            return false;
        }
        if(!closureDetails.Day) {
            setErrors('Day name is required');
            return false;
        }

        return true;
    }

    const saveChanges = async () => {
        if (!allowManagement) return;
        if(!checks()) return;
        let newClosures = [...profile.Closures];
        if (selectedClosure) {
            newClosures[selectedClosure.index] = closureDetails;
        } else {
            newClosures.push(closureDetails);
        }

        const response = await putCompanyProfile({
            ...profile,
            Closures: newClosures
        });
        if (response.success) {
            setProfile({...response.data});
            setOpen(false);
        } else {
            setErrors(response.error.Message);
        }
    }

    return (
        <Dialog
            maxWidth="md"
            open={open}
            onClose={() => setOpen(false)}
            fullWidth={true}
        >
            <Toolbar className='lbtoolbar'>Edit Closure</Toolbar>
            <DialogContent>
                <Grid container style={{gap: '1em'}}>
                    <Grid container item xs={12} style={{gap: "0.5rem"}}>
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   label='Day Name' value={closureDetails?.Day ?? ""}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setClosureDetails((prev) => ({
                                           ...prev,
                                           Day: value
                                       }))
                                   }}
                        />
                    </Grid>

                    <Grid container item xs={12} style={{gap: "0.5rem"}}>
                        {/*// Start Day and End Day date selectors*/}
                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   type={'date'}
                                   label='Start Date' value={moment(closureDetails?.Start ?? "").format("YYYY-MM-DD")}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setClosureDetails((prev) => ({
                                           ...prev,
                                           Start: value === "" ? "" : moment(value).format("YYYY-MM-DDT23:59:59")
                                       }))
                                   }}
                        />

                        <TextField InputLabelProps={{shrink: true}} style={{flex: 1}}
                                   disabled={!allowManagement}
                                   type={'date'}
                                   InputProps={{inputProps: { min: moment(closureDetails?.Start ?? "").format("YYYY-MM-DD")}}}
                                   label='End Date (Optional)' value={moment(closureDetails?.End ?? "").format("YYYY-MM-DD")}
                                   onChange={(e) => {
                                       const {value} = e.target;
                                       setClosureDetails((prev) => ({
                                           ...prev,
                                           End: value === "" ? "" : moment(value).format("YYYY-MM-DDT23:59:59")
                                       }))
                                   }}
                        />
                    </Grid>

                    <Grid container item xs={12} style={{flexDirection: "column"}}>
                        <Typography style={{fontWeight: "bold"}}>
                            Warehouses
                        </Typography>

                        <Typography
                            style={{cursor: "pointer", color: "#4d57f8", padding: "0.5em 0"}}
                            onClick={() => {
                                setClosureDetails((prev) => ({
                                    ...prev,
                                    Warehouses: prev.Warehouses.length === profile.Warehouses.length ? [] : profile.Warehouses.map(w => w.Code)
                                }))
                            }}>
                            {closureDetails.Warehouses.length === profile.Warehouses.length ? "Deselect All" : "Select All"}
                        </Typography>

                        <Grid container style={{flexDirection: "column", maxHeight: "350px"}}>
                            {profile.Warehouses.map((warehouse, index) => (
                                <FormControlLabel
                                    control={<Checkbox disabled={!allowManagement} checked={closureDetails.Warehouses.includes(warehouse.Code)} />}
                                    label={warehouse.Name}
                                    onChange={(e) => {
                                        const {checked} = e.target;
                                        setClosureDetails((prev) => ({
                                            ...prev,
                                            Warehouses: checked ? [...prev.Warehouses, warehouse.Code] : prev.Warehouses.filter(w => w !== warehouse.Code)
                                        }))
                                    }}
                                />
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                {allowManagement && (
                    <Button
                        type='submit'
                        color="primary"
                        onClick={() => saveChanges()}
                    >
                        Save
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}

const HoursOfOperationDialog = (props) => {
    const {open, setOpen} = props;
    const {profile, setProfile} = props;
    const {allowManagement, setErrors} = props;

    const built = [...profile.Hours];
    const [hoursDetails, setHoursDetails] = React.useState(built);
    const [timezone, setTimezone] = React.useState(built[0]?.TimeZone ?? "");

    const updateHour = (newHour) => {
        const foundHour = hoursDetails.find(h => h.Day === newHour.Day);
        if (foundHour) {
            setHoursDetails((prev) => {
                return prev.map(h => h.Day === newHour.Day ? newHour : h);
            })
        }
        else {
            setHoursDetails((prev) => {
                return [...prev, newHour];
            })
        }
    }

    const saveChanges = async () => {
        if (!allowManagement) return;

        const response = await putCompanyProfile({
            ...profile,
            Hours: hoursDetails.map(hour => {
                return {
                    ...hour,
                    TimeZone: timezone
                }
            })
        });
        if (response.success) {
            setProfile({...response.data});
            setOpen(false);
        } else {
            setErrors(response.error.Message);
        }
    }

    return (
        <Dialog
            maxWidth="md"
            open={open}
            onClose={() => setOpen(false)}
            fullWidth={true}
        >
            <Toolbar className='lbtoolbar'>Edit Hours of Operation</Toolbar>
            <DialogContent>
                <Grid container style={{gap: '1em'}}>
                    <Grid container item xs={12} style={{gap: "0.5rem"}}>
                        <ExtendedSelect style={{flex: 1}} label='Time Zone'
                                        options={timezones.map(r => ({label: r, value: r}))}
                                        value={timezone ?? ""}
                                        onChange={(e) => {
                                            setTimezone(e);
                                        }}
                        />
                    </Grid>

                    <Grid container item style={{flexDirection: "column", gap: "1em"}}>
                        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(day => {
                            let found = hoursDetails.find(h => h.Day === day);
                            if (!found) {
                                found = {...defaultHour, Day: day};
                            }

                            return (
                                <Grid item container style={{gap: "1em", justifyContent: "center", alignItems: "center"}}>
                                    <Typography style={{fontWeight: "bold", width: "80px", fontSize: "14px"}}>
                                        {found.Day}
                                    </Typography>

                                    <ExtendedSelect
                                        style={{flex: 1}} label='Open Time'
                                        options={Array.from({length: 24}, (v, k) => k).map(r => ({
                                            label: moment(r, 'H').format('h:mm A'),
                                            value: moment(r, 'H').format('HH:mm')
                                        }))}
                                        controlled={true}
                                        value={moment(found?.OpenTime, 'HH:mm').format('HH:mm') ?? ""}
                                        onChange={(e) => {
                                            const newHour = {...found, OpenTime: e.toString(), Closed: false};
                                            updateHour(newHour);
                                        }}
                                    />

                                    <ExtendedSelect
                                        style={{flex: 1}} label='Close Time'
                                        options={Array.from({length: 24}, (v, k) => k)
                                            // Filter out times equal to and before OpenTime
                                            .filter(r => r > moment(found?.OpenTime, 'HH:mm').hour())
                                            .map(r => ({
                                                label: moment(r, 'H').format('h:mm A'),
                                                value: moment(r, 'H').format('HH:mm')
                                            }))}
                                        controlled={true}
                                        value={moment(found?.CloseTime, 'HH:mm').format('HH:mm') ?? ""}
                                        onChange={(e) => {
                                            const newHour = {...found, CloseTime: e.toString(), Closed: false};
                                            updateHour(newHour);
                                        }}
                                    />

                                    <FormControlLabel
                                        control={<Checkbox checked={found?.Closed ?? false}/>}
                                        label='Closed'
                                        onChange={(e) => {
                                            const newHour = {...found, CloseTime: "", OpenTime: "", Closed: e.target.checked};
                                            updateHour(newHour);
                                        }}
                                    />
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                {allowManagement && (
                    <Button
                        type='submit'
                        color="primary"
                        onClick={() => saveChanges()}
                    >
                        Save
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}
//endregion

//region Tabs
export const MerchandisingTab = (props) => {
    const {profile, setProfile, selectedTab} = props;
    const {allowManagement, setErrors} = props;

    const [merchandisingEditOpen, setMerchandisingEditOpen] = useState(false);

    return (
        <TabPanel value={selectedTab} index={0}
                  style={{textAlign: "left", padding: "1em"}}
        >
            <Grid container>
                <Grid item sm={6} md={6} lg={6} style={{display: 'flex', flexDirection: 'column'}}>
                    <Typography variant='h6'>Basics</Typography>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <TextField style={{flex: 1}} disabled label="Merchandiser first name" value={!profile.MerchandiserContact?.FirstName ? " " : profile.MerchandiserContact?.FirstName}/>
                        <TextField style={{flex: 1}} disabled label="Merchandiser last name" value={!profile.MerchandiserContact?.LastName ? " " : profile.MerchandiserContact?.LastName}/>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <TextField style={{flex: 1}} disabled label="Merchandiser title" value={!profile.MerchandiserContact?.Title ? " " : profile.MerchandiserContact?.Title}/>
                        <TextField style={{flex: 1}} disabled label="Merchandiser email address" value={!profile.MerchandiserContact?.Email ? " " : profile.MerchandiserContact?.Email}/>
                    </div>
                    <TextField style={{flex: 1}} disabled label="Website" value={!profile.Website ? " " : profile.Website}/>
                    <TextField style={{flex: 1}} disabled label="Categories" value={(profile.Categories ?? []).sort().join(", ") || ' '}/>
                    <TextField style={{flex: 1}} disabled label="Subcategory" value={!profile.Subcategory ? " " : profile.Subcategory}/>
                </Grid>

                <Grid item sm={6} md={6} lg={6}>
                    <Typography variant='h6'>Description</Typography>
                    <div dangerouslySetInnerHTML={{__html: profile.Description ?? ""}}></div>
                </Grid>

                {allowManagement && (
                    <div style={{marginTop: '1em'}}>
                        <Button variant='contained' onClick={() => setMerchandisingEditOpen(true)}>Edit</Button>
                    </div>
                )}
            </Grid>

            {merchandisingEditOpen && (
                <MerchandisingDialog
                    setErrors={setErrors}
                    open={merchandisingEditOpen}
                    setOpen={setMerchandisingEditOpen}
                    profile={profile}
                    setProfile={setProfile}
                    allowManagement={allowManagement}
                />
            )}
        </TabPanel>
    );
}

export const ContactsTab = (props) => {
    const {profile, setProfile, selectedTab} = props;
    const {allowManagement, setErrors} = props;

    const profileRef = useRef();
    profileRef.current = profile;

    const [contactsOpen, setContactsOpen] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null);
    const [config, setConfig] = useState({
        getData: async function(){
            return [
                {...profileRef.current.CustomerServiceContact, type: "CustomerServiceContact", TypeLabel: "Customer Service"},
                {...profileRef.current.ITContact, type: "ITContact", TypeLabel: "IT"},
                {...profileRef.current.OperationsContact, type: "OperationsContact", TypeLabel: "Operations"},
                {...profileRef.current.PartnershipContact, type: "PartnershipContact", TypeLabel: "Partnership"}
            ];
        },
        columns: [
            {id: 'type', hidden: true},
            {id: 'TypeLabel', label: 'Contact Type', width: "18em"},
            {id: 'FirstName', filterable: true, sortable: true, searchable: true, label: 'First Name'},
            {id: 'LastName', filterable: true, sortable: true, searchable: true, label: 'Last Name'},
            {id: 'Email', filterable: true, sortable: true, searchable: true, label: 'Email'},
            {id: 'Title', hidden: true},
            {
                filterable: false,
                id: 'actions',
                width: '7em',
                cellStyle: {padding: 0},
                template: (row, column, colIndex, rowIndex) => (
                    <Grid container style={{gap: "0.5em"}}>
                        {allowManagement && (
                            <>
                                <Button variant={"outlined"}
                                        onClick={() => {
                                            setSelectedContact({
                                                type: row.type,
                                                ...row
                                            });
                                            setContactsOpen(true);
                                        }}
                                >
                                    Edit
                                </Button>
                            </>
                        )}
                    </Grid>
                )
            }
        ],
        order: 'asc',
        orderBy: 'Name',
        keyField: 'Id',
        pageSize: 20,
        filter: null,
        refresh: false,
        pageSizes: [10, 20, 50, 100],
        title: 'Contacts'
    });

    useEffect(() => {
        setConfig(prev => ({
            ...prev,
            refresh: !prev.refresh
        }))

        // eslint-disable-next-line
    }, [profileRef.current]);

    return (
        <TabPanel value={selectedTab} index={1}>
            <EnhancedTable config={config} history={props.history} location={props.location}
                           key={"profile_contacts_table"}
                           template={(table) =>
                               <CatalogManagerResults
                                   isSelectable={false}
                                   disableTermInUrl={true}
                                   disableColumnSelector={true}
                                   disableDetailedFilters={true}
                                   disableSearch={true}
                                   noFilters={true}
                                   condensed={true}
                                   noToolBar={true}
                                   history={props.history} location={props.location}
                                   table={table}
                                   config={config} setConfig={setConfig}
                                   resultsContainerStyles={{gap: "1em"}}
                                   renderButtonFiltersAfter={false}
                               />
                           }
            />

            {contactsOpen && (
                <ContactsDialog
                    setErrors={setErrors}
                    open={contactsOpen}
                    setOpen={setContactsOpen}
                    profile={profileRef.current}
                    setProfile={setProfile}
                    selectedContact={selectedContact}
                    allowManagement={allowManagement}
                />
            )}
        </TabPanel>
    );
}

export const WarehousesTab = (props) => {
    const {setUpdating} = props;
    const {profile, setProfile, selectedTab} = props;
    const {allowManagement, setErrors} = props;

    const profileRef = useRef();
    profileRef.current = profile;

    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [confirmClearOpen, setConfirmClearOpen] = useState(false);
    const [warehouseEditOpen, setWarehouseEditOpen] = useState(false);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [config, setConfig] = useState({
        getData: async function(){
            return profileRef.current.Warehouses || [];
        },
        columns: [
            {id: 'Name', filterable: true, sortable: true, searchable: true, label: 'Name'},
            {id: 'Code', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'Code'},
            {id: 'Type', filterable: true, sortable: true, searchable: true, label: 'Type',
                getOptions: async () => {
                    return [
                        {label: 'Warehouse', value: 'Warehouse'},
                        {label: 'Externally-Managed', value: 'Externally-Managed'},
                        {label: 'Dropship', value: 'Dropship'},
                        {label: 'Retail Store', value: 'Retail Store'},
                    ]
                }
            },
            {id: 'Address1', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'Address',
                allowStringOperators: true,
                template: (row, column, colIndex, rowIndex) => (
                    <>
                        {row.Address1 && (
                            <Typography>
                                {row.Address1} {row.Address2}, {row.City} {row.State}, {row.Zip}, {row.Country}
                            </Typography>
                        )}
                    </>
                )
            },
            {id: 'Address2', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'Address 2',
                hidden: true,
                template: (row, column, colIndex, rowIndex) => (
                    <>
                        {row.Address2 && (
                            <Typography>
                                {row.Address2}, {row.City} {row.State}, {row.Zip}, {row.Country}
                            </Typography>
                        )}
                    </>
                )
            },
            {id: 'City', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'City', hidden: "true"},
            {id: 'State', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'State', hidden: "true"},
            {id: 'Zip', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'Zip', hidden: "true"},
            {id: 'Country', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'Country', hidden: "true"},
            {
                filterable: false,
                id: 'actions',
                width: '14em',
                cellStyle: {padding: 0},
                template: (row, column, colIndex, rowIndex) => (
                    <Grid container style={{gap: "0.5em"}}>
                        {allowManagement && (
                            <>
                                <Button variant={"outlined"}
                                        onClick={() => {
                                            setSelectedWarehouse({
                                                index: rowIndex,
                                                ...row
                                            });
                                            setWarehouseEditOpen(true);
                                        }}
                                >
                                    Edit
                                </Button>

                                <Button variant={"outlined"}
                                    onClick={() => clearWarehouse(row.Code)}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                    </Grid>
                )
            }
        ],
        order: 'asc',
        orderBy: 'Name',
        keyField: 'Id',
        pageSize: 20,
        filter: null,
        refresh: false,
        pageSizes: [10, 20, 50, 100],
        title: 'Warehouses'
    });

    const clearAllWarehouses = async () => {
        if (!allowManagement) return;
        setUpdating(true);
        const response = await putCompanyProfile({
            ...profileRef.current,
            Warehouses: [],
            Closures: profileRef.current.Closures.map(closure => {
                return {
                    ...closure,
                    Warehouses: []
                }
            })
        });
        if (response.success) {
            setProfile({...response.data});
        } else {
            setErrors(response.error.Message);
        }
        setConfirmClearOpen(false);
        setUpdating(false);
    }

    const clearWarehouse = async (warehouseId) => {
        if (!allowManagement) return;
        setUpdating(true);
        const response = await putCompanyProfile({
            ...profileRef.current,
            Warehouses: profileRef.current.Warehouses.filter(w => w.Code !== warehouseId),
            Closures: profileRef.current.Closures.map(closure => {
                return {
                    ...closure,
                    Warehouses: closure.Warehouses ? closure.Warehouses.filter(w => w !== warehouseId) : []
                }
            })
        });
        if (response.success) {
            setProfile({...response.data});
        } else {
            setErrors(response.error.Message);
        }
        setUpdating(false);
    }

    const importWarehouses = async (mappedRecords) => {
        const response = await putCompanyProfile({
            ...profileRef.current,
            Warehouses: [...profileRef.current.Warehouses, ...mappedRecords]
        });
        if (response.success) {
            setProfile({...response.data});
        } else {
            setErrors(response.error.Message);
        }
    }

    const exportWarehouses = () => {
        let header = ["Name", "Type", "Code", "Address1", "Address2", "City", "State", "Zip", "Country"];
        let rows = [header].concat(profileRef.current.Warehouses.map(w => [
            w.Name,
            w.Type,
            w.Code,
            w.Address1,
            w.Address2,
            w.City,
            w.State,
            w.Zip,
            w.Country
        ]).map(row => row.map(cell => cell === null || cell === undefined ? "" : cell.toString())));
        let output = stringify(rows);
        let blob = new Blob([output], { type: "text/csv" });
        FileSaver.saveAs(blob, 'warehouses.csv');
    }

    useEffect(() => {
        setConfig(prev => ({
            ...prev,
            refresh: !prev.refresh
        }))
    }, [profileRef.current.Warehouses]);

    return (
        <TabPanel value={selectedTab} index={2}>
            <EnhancedTable config={config} history={props.history} location={props.location}
                           key={"profile_warehouse_table"}
                           template={(table) =>
                               <CatalogManagerResults
                                   isSelectable={false}
                                   disableTermInUrl={true}
                                   condensed={true}
                                   noToolBar={true}
                                   history={props.history} location={props.location}
                                   table={table}
                                   config={config} setConfig={setConfig}
                                   resultsContainerStyles={{gap: "1em"}}
                                   renderButtonFiltersAfter={false}
                                   buttonFilters={
                                       <Grid container style={{gap: "0.5em", flex: 1}}>
                                           <Button variant={"outlined"}
                                            onClick={() => {
                                                setSelectedWarehouse(null);
                                                setWarehouseEditOpen(true);
                                            }}
                                           >
                                               New
                                           </Button>

                                           <Button variant={"outlined"}
                                            onClick={() => setImportDialogOpen(true)}
                                           >
                                               Import CSV
                                           </Button>

                                           <DownloadButton variant='contained'
                                            onClick={() => exportWarehouses()}
                                           >
                                               Export CSV
                                           </DownloadButton>

                                           <Button variant={"outlined"} disabled={!allowManagement}
                                            onClick={() => {
                                                setConfirmClearOpen(true);
                                            }}
                                           >
                                               Clear All
                                           </Button>
                                       </Grid>
                                   }
                               />
                           }
            />

            {warehouseEditOpen && (
                <WarehousesDialog
                    setErrors={setErrors}
                    open={warehouseEditOpen}
                    setOpen={setWarehouseEditOpen}
                    profile={profileRef.current}
                    setProfile={setProfile}
                    selectedWarehouse={selectedWarehouse}
                    allowManagement={allowManagement}
                />
            )}

            {importDialogOpen && (
                <ImportDialog
                    headers={["Name", "Type", "Code", "Address1", "Address2", "City", "State", "Zip", "Country"]}
                    open={importDialogOpen}
                    setOpen={setImportDialogOpen}
                    title={"Import Warehouses"}
                    mapFunction={warehouseImportMapper}
                    setError={setErrors}
                    updateProfile={async (mappedRecords) => {
                        await importWarehouses(mappedRecords);
                    }}
                />
            )}

            {confirmClearOpen && (
                <Dialog open={confirmClearOpen} onClose={() => setConfirmClearOpen(false)}>
                    <DialogTitle>Clear All Warehouses</DialogTitle>
                    <DialogContent style={{padding: "0 24px 0"}}>
                        <DialogContentText>
                            Are you sure you want to clear all warehouses?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setConfirmClearOpen(false)}
                            color="primary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                clearAllWarehouses();
                            }}
                            color="primary"
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </TabPanel>
    );
}

export const ClosuresTab = (props) => {
    const {setUpdating} = props;
    const {profile, setProfile, selectedTab} = props;
    const {allowManagement, setErrors} = props;

    const profileRef = useRef();
    profileRef.current = profile;

    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [confirmClearOpen, setConfirmClearOpen] = useState(false);
    const [closureEditOpen, setClosureEditOpen] = useState(false);
    const [selectedClosure, setSelectedClosure] = useState(null);
    const [config, setConfig] = useState({
        getData: async function(){
            return profileRef.current.Closures || [];
        },
        columns: [
            { id: 'Day', filterable: true, sortable: true, searchable: true, label: 'Day Name' },
            {
                id: 'Start',
                label: 'Start Date',
                type: "date",
                hidden: false,
                toggleable: true,
                sortable: true,
                template: (row) => {
                    if (row.Start)
                        return moment(row.Start).format("MM/DD/YYYY");
                }
            },
            {
                id: 'End',
                label: 'End Date',
                type: "date",
                hidden: false,
                toggleable: true,
                sortable: true,
                template: (row) => {
                    if (row.End)
                        return moment(row.End).format("MM/DD/YYYY");
                }
            },
            {
                id: 'Warehouses',
                filterable: true,
                toggleable: true,
                sortable: true,
                searchable: true,
                label: 'Warehouse Codes',
                allowStringOperators: true,
                template: (row, column, colIndex, rowIndex) => (
                    <>
                        {row.Warehouses && row.Warehouses.join(", ")}
                    </>
                )
            },
            {
                filterable: false,
                id: 'actions',
                width: '14em',
                cellStyle: {padding: 0},
                template: (row, column, colIndex, rowIndex) => (
                    <Grid container style={{gap: "0.5em"}}>
                        {allowManagement && (
                            <>
                                <Button variant={"outlined"}
                                        onClick={() => {
                                            setSelectedClosure({
                                                index: rowIndex,
                                                ...row
                                            });
                                            setClosureEditOpen(true);
                                        }}
                                >
                                    Edit
                                </Button>

                                <Button variant={"outlined"}
                                    onClick={() => clearClosure(rowIndex)}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                    </Grid>
                )
            }
        ],
        order: 'asc',
        orderBy: 'Day',
        keyField: 'Id',
        pageSize: 20,
        filter: null,
        refresh: false,
        pageSizes: [10, 20, 50, 100],
        title: 'Closures'
    });

    const clearAllClosures = async () => {
        if (!allowManagement) return;
        setUpdating(true);
        const response = await putCompanyProfile({
            ...profileRef.current,
            Closures: []
        });
        if (response.success) {
            setProfile({...response.data});
        } else {
            setErrors(response.error.Message);
        }
        setConfirmClearOpen(false);
        setUpdating(false);
    }

    const clearClosure = async (closureIndex) => {
        if (!allowManagement) return;
        setUpdating(true);
        const response = await putCompanyProfile({
            ...profileRef.current,
            Closures: profileRef.current.Closures.filter((c, index) => index !== closureIndex)
        });
        if (response.success) {
            setProfile({...response.data});
        } else {
            setErrors(response.error.Message);
        }
        setUpdating(false);
    }

    const importClosure = async (mappedRecords) => {
        const response = await putCompanyProfile({
            ...profileRef.current,
            Closures: [...profileRef.current.Closures, ...mappedRecords]
        });
        if (response.success) {
            setProfile({...response.data});
        } else {
            setErrors(response.error.Message);
        }
    }

    const exportClosures = () => {
        let header = ["Day", "Start", "End", "Warehouse Codes"];

        let rows = [header].concat(profileRef.current.Closures.map(w => [
            w.Day,
            moment(w.Start).format("YYYY-MM-DD"),
            moment(w.End).format("YYYY-MM-DD"),
            w.Warehouses && w.Warehouses.join(", ")
        ]).map(row => row.map(cell => cell === null || cell === undefined ? "" : cell.toString())));
        let output = stringify(rows);
        let blob = new Blob([output], { type: "text/csv" });
        FileSaver.saveAs(blob, 'closures.csv');
    }

    useEffect(() => {
        setConfig(prev => ({
            ...prev,
            refresh: !prev.refresh
        }))
    }, [profileRef.current.Closures]);

    return (
        <TabPanel value={selectedTab} index={3}>
            <EnhancedTable config={config} history={props.history} location={props.location}
                           key={"profile_closure_table"}
                           template={(table) =>
                               <CatalogManagerResults
                                   isSelectable={false}
                                   disableTermInUrl={true}
                                   condensed={true}
                                   noToolBar={true}
                                   history={props.history} location={props.location}
                                   table={table}
                                   config={config} setConfig={setConfig}
                                   resultsContainerStyles={{gap: "1em"}}
                                   renderButtonFiltersAfter={false}
                                   buttonFilters={
                                       <Grid container style={{gap: "0.5em", flex: 1}}>
                                           <Button variant={"outlined"}
                                                   onClick={() => {
                                                       setSelectedClosure(null);
                                                       setClosureEditOpen(true);
                                                   }}
                                           >
                                               New
                                           </Button>

                                           <Button variant={"outlined"}
                                                    onClick={() => setImportDialogOpen(true)}
                                           >
                                               Import CSV
                                           </Button>

                                           <DownloadButton variant='contained'
                                                  onClick={() => exportClosures()}
                                           >
                                               Export CSV
                                           </DownloadButton>

                                           <Button variant={"outlined"} disabled={!allowManagement}
                                                   onClick={() => {
                                                       setConfirmClearOpen(true);
                                                   }}
                                           >
                                               Clear All
                                           </Button>
                                       </Grid>
                                   }
                               />
                           }
            />

            {closureEditOpen && (
                <ClosuresDialog
                    setErrors={setErrors}
                    open={closureEditOpen}
                    setOpen={setClosureEditOpen}
                    profile={profileRef.current}
                    setProfile={setProfile}
                    selectedClosure={selectedClosure}
                    allowManagement={allowManagement}
                />
            )}

            {importDialogOpen && (
                <ImportDialog
                    headers={["Day", "Start", "End", "Warehouse Codes"]}
                    open={importDialogOpen}
                    setOpen={setImportDialogOpen}
                    title={"Import Closures"}
                    mapFunction={closureImportMapper}
                    setError={setErrors}
                    updateProfile={async (mappedRecords) => {
                        await importClosure(mappedRecords);
                    }}
                />
            )}

            {confirmClearOpen && (
                <Dialog open={confirmClearOpen} onClose={() => setConfirmClearOpen(false)}>
                    <DialogTitle>Clear All Warehouses</DialogTitle>
                    <DialogContent style={{padding: "0 24px 0"}}>
                        <DialogContentText>
                            Are you sure you want to clear all closures?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setConfirmClearOpen(false)}
                            color="primary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                clearAllClosures();
                            }}
                            color="primary"
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </TabPanel>
    );
}

export const HoursOfOperationTab = (props) => {
    const {setUpdating} = props;
    const {profile, setProfile, selectedTab} = props;
    const {allowManagement, setErrors} = props;

    const profileRef = useRef();
    profileRef.current = profile;

    const [confirmClearOpen, setConfirmClearOpen] = useState(false);
    const [hoursEditOpen, setHoursEditOpen] = useState(false);
    const [config, setConfig] = useState({
        getData: async function(){
            return profileRef.current.Hours.sort((a, b) => {
                return ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].indexOf(a.Day) - ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].indexOf(b.Day);
            }).reverse();
        },
        columns: [
            {id: 'Day', filterable: true, sortable: true, searchable: true, label: 'Day'},
            {id: 'OpenTime', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'Open Time',
                template: (row) => {
                    return row.Closed ? "Closed" : moment(row.OpenTime, 'HH:mm').format('h:mm A');
                }
            },
            {id: 'CloseTime', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'Close Time',
                template: (row) => {
                    return row.Closed ? "Closed" : moment(row.CloseTime, 'HH:mm').format('h:mm A');
                }
            },
            {id: 'TimeZone', filterable: true, toggleable: true, sortable: true, searchable: true, label: 'Time Zone'},
            {id: 'Closed', hidden: true, filterable: true, toggleable: true, sortable: true, searchable: true, label: 'Closed'},
{
                filterable: false,
                id: 'actions',
                width: '7em',
                cellStyle: {padding: 0},
                template: (row, column, colIndex, rowIndex) => (
                    <Grid container style={{gap: "0.5em"}}>
                        {allowManagement && (
                            <>
                                <Button variant={"outlined"}
                                        onClick={() => {
                                            clearHours(row.Day);
                                        }}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                    </Grid>
                )
            }
        ],
        order: 'asc',
        keyField: 'Id',
        pageSize: 20,
        filter: null,
        refresh: false,
        pageSizes: [10, 20, 50, 100],
        title: 'Hours Of Operation'
    });

    const clearAllHours = async () => {
        if (!allowManagement) return;
        setUpdating(true);
        const response = await putCompanyProfile({
            ...profileRef.current,
            Hours: []
        });
        if (response.success) {
            setProfile({...response.data});
        } else {
            setErrors(response.error.Message);
        }
        setConfirmClearOpen(false);
        setUpdating(false);
    }

    const clearHours = async (day) => {
        if (!allowManagement) return;
        setUpdating(true);
        const response = await putCompanyProfile({
            ...profileRef.current,
            Hours: profileRef.current.Hours.filter(h => h.Day !== day)
        });
        if (response.success) {
            setProfile({...response.data});
        } else {
            setErrors(response.error.Message);
        }
        setUpdating(false);
    }

    useEffect(() => {
        setConfig(prev => ({
            ...prev,
            refresh: !prev.refresh
        }))
    }, [profileRef.current.Hours]);

    return (
        <TabPanel value={selectedTab} index={4}>
            <EnhancedTable config={config} history={props.history} location={props.location}
                           key={"profile_hours_table"}
                           template={(table) =>
                               <CatalogManagerResults
                                   isSelectable={false}
                                   disableTermInUrl={true}
                                   condensed={true}
                                   noToolBar={true}
                                   history={props.history} location={props.location}
                                   table={table}
                                   config={config} setConfig={setConfig}
                                   resultsContainerStyles={{gap: "1em"}}
                                   renderButtonFiltersAfter={false}
                                   buttonFilters={
                                       <Grid container style={{gap: "0.5em", flex: 1}}>
                                           <Button variant={"outlined"}
                                                   onClick={() => {
                                                       setHoursEditOpen(true);
                                                   }}
                                           >
                                               Edit
                                           </Button>

                                           <Button variant={"outlined"} disabled={!allowManagement}
                                                   onClick={() => {
                                                       setConfirmClearOpen(true);
                                                   }}
                                           >
                                               Clear All
                                           </Button>
                                       </Grid>
                                   }
                               />
                           }
            />

            {hoursEditOpen && (
                <HoursOfOperationDialog
                    setErrors={setErrors}
                    open={hoursEditOpen}
                    setOpen={setHoursEditOpen}
                    profile={profileRef.current}
                    setProfile={setProfile}
                    allowManagement={allowManagement}
                />
            )}

            {confirmClearOpen && (
                <Dialog open={confirmClearOpen} onClose={() => setConfirmClearOpen(false)}>
                    <DialogTitle>Clear All Hours</DialogTitle>
                    <DialogContent style={{padding: "0 24px 0"}}>
                        <DialogContentText>
                            Are you sure you want to clear all hours of operation?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setConfirmClearOpen(false)}
                            color="primary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                clearAllHours();
                            }}
                            color="primary"
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </TabPanel>
    );
}
//endregion

const ProfileSection = (props) => {
    const {setErrors} = props;

    const [updating, setUpdating] = useState(false);
    const [loading, setLoading] = useState(true);
    const [profile, setProfile] = React.useState(defaultProfile);
    const [selectedTab, setSelectedTab] = React.useState(0);

    const allowManagement = Auth.hasPermission("settings/manage");

    const a11yProps = (index) => {
        return {
            id: `profile-tab-${index}`,
            'aria-controls': `profile-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    useEffect(() => {
        const getProfile = async () => {
            setLoading(true);

            const resposne = await fetchCompanyProfile();
            if(!resposne.success) {
                setErrors(resposne.error.Message);
                return;
            }

            const profile = {...resposne.data};
            setProfile({...defaultProfile, ...profile});
            setLoading(false);
        }

        getProfile();

        // eslint-disable-next-line
    }, []);

    return (
        <Card style={{flex: 1}}>
            <Toolbar className='lbtoolbar'>Profile</Toolbar>
            <Tabs value={selectedTab} onChange={handleChange} style={{padding: "1em"}}>
                <Tab label={"Merchandising"} {...a11yProps(0)} />
                <Tab label={"Contacts"} {...a11yProps(1)}/>
                <Tab label={"Warehouses"} {...a11yProps(2)}/>
                <Tab label={"Closures"} {...a11yProps(3)}/>
                <Tab label={"Hours of Operation"} {...a11yProps(4)}/>
            </Tabs>

            {loading ? (
                <div style={{padding: "0.5em"}}>
                    <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                </div>
            ) : (
                <>
                    <MerchandisingTab
                        setUpdating={setUpdating}
                        setErrors={setErrors}
                        allowManagement={allowManagement}
                        profile={profile}
                        setProfile={setProfile}
                        selectedTab={selectedTab}/>
                    <ContactsTab
                        setUpdating={setUpdating}
                        setErrors={setErrors}
                        allowManagement={allowManagement}
                        profile={profile}
                        setProfile={setProfile}
                        selectedTab={selectedTab}/>
                    <WarehousesTab
                        setUpdating={setUpdating}
                        setErrors={setErrors}
                        allowManagement={allowManagement}
                        profile={profile}
                        setProfile={setProfile}
                        selectedTab={selectedTab}/>
                    <ClosuresTab
                        setUpdating={setUpdating}
                        setErrors={setErrors}
                        allowManagement={allowManagement}
                        profile={profile}
                        setProfile={setProfile}
                        selectedTab={selectedTab}/>
                    <HoursOfOperationTab
                        setUpdating={setUpdating}
                        setErrors={setErrors}
                        allowManagement={allowManagement}
                        profile={profile}
                        setProfile={setProfile}
                        selectedTab={selectedTab}/>
                </>
            )}

            <GenericDialog open={updating} title="Updating" message="Updating profile..." />
        </Card>
    )
}

class AccountInformation extends Component {
    state = {company: {}, showEdit: false, showError: false};

    setErrors = (errorContent) => {
        this.setState({showError: true, errorContent});
    }

    async componentDidMount(){
        var company = (await axios.get(Config.api + "/odata/Company")).data;
        this.setState({company, loaded: true});
    }

    render(){

        let config = {
            getData: async function(){
                var data = (await axios.get(Config.api + '/api/v1/partners')).data.Body.Partners;
                return data.map(row => {
                    var vendorCode = null;
                    if(row.VendorCodes && row.VendorCodes.length > 0){
                        var portalCode = row.VendorCodes.find(r => r.System === 'Portal');
                        if(portalCode){
                            vendorCode = portalCode.Code;
                        }
                    }
                    return {Id: row.Id, CompanyName: row.CompanyName, VendorNumber: vendorCode };
                });
            },
            columns: [
              { id: "Id", filterable: true, sortable: true, label: 'Account Number', width: '13em' },
              { id: 'VendorNumber', filterable: true, sortable: true, label: 'Vendor Number', width: '13em' },
              { id: 'CompanyName', filterable: true, sortable: true, label: 'Company Name', getOptions: getCompanyNames }
          ],
          order: 'asc',
          orderBy: 'CompanyName',
          keyField: 'Id',
          pageSize: 20,
          pageSizes: [10, 20, 50, 100],
          title: 'Partners'
        };
        return (<Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} style={{display: 'flex'}}>
                <Card style={{flex: 1}}>
                    <Toolbar className='lbtoolbar'>Account Basics</Toolbar>
                    <CardContent className={this.props.classes.card}>
                        <div style={{display: 'flex'}}>
                            <TextField disabled label="Account Name" value={this.state.company.CompanyName || ' '}/>
                            <TextField disabled label="Account Number" value={this.state.company.CoId || ' '}/>
                        </div>
                        <div style={{display: 'flex'}}>
                            <TextField disabled label="Street 1" value={this.state.company.Address1 || ' '}/>
                            <TextField disabled label="Street 2" value={this.state.company.Address2 || ' '}/>
                        </div>
                        <div style={{display: 'flex'}}>
                            <TextField disabled label="City" value={this.state.company.City || ' '}/>
                            <TextField style={{flex: 1}} disabled label="State" value={this.state.company.State || ' '}/>
                            <TextField style={{flex: 1}} disabled label="ZIP Code" value={this.state.company.Zip || ' '}/>
                            <TextField style={{flex: 1}} disabled label="Country" value={this.state.company.Country || ' '}/>
                        </div>
                        <div style={{display: 'flex'}}>
                            <TextField style={{flex: 1}} disabled label="Email" value={this.state.company.Email || ' '}/>
                            <TextField style={{flex: 1}} disabled label="Phone" value={this.state.company.Phone1 || ' '}/>
                        </div>
                    </CardContent>
                </Card>
            </Grid>

            <CompanyLogos gridItem={{lg: 6, md: 6, sm: 12, xs: 12}}/>

            <Grid item xs={12} sm={12} md={12} lg={12}>
                <ProfileSection
                    isRetailer={this.props.isRetailer}
                    classes={this.props.classes}
                    setErrors={this.setErrors}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
                <EnhancedTable config={config}/>
            </Grid>

            <Dialog maxWidth="sm" open={this.state.showError} onClose={() => this.setState({showError: false})}>
                <Toolbar className='lbtoolbar'>Error</Toolbar>
                    <DialogContent>
                      <Typography>{this.state.errorContent}</Typography>
                    </DialogContent>
                  </Dialog>
            </Grid>);
    }
}

export default withStyles(styles)(AccountInformation);

export {categories as Categories};
